import _Number$MIN_SAFE_INTEGER from 'babel-runtime/core-js/number/min-safe-integer';
import _Number$MAX_SAFE_INTEGER from 'babel-runtime/core-js/number/max-safe-integer';

export default {
  name: 'editGameDifficultySliderPopover.vue',

  props: {
    title: {
      type: String,
      required: true
    },
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    }
  },

  data: function data() {
    return {
      editButtonParams: {
        type: 'text',
        class: 'edit-button',
        icon: 'el-icon-edit'
      },

      formValue: {
        min: this.min,
        max: this.max
      },

      editPopoverVisible: false
    };
  },


  computed: {
    formItemList: function formItemList() {
      return [{
        type: 'input-number',
        label: this.$t('playTurbo.custom.difficultySlider.form.min.label'),
        prop: 'min',
        rules: [{
          required: true,
          message: this.$t('playTurbo.custom.difficultySlider.form.min.required'),
          trigger: 'change'
        }, {
          validator: this.validateNumber,
          trigger: 'change'
        }]
      }, {
        type: 'input-number',
        label: this.$t('playTurbo.custom.difficultySlider.form.max.label'),
        prop: 'max',
        rules: [{
          required: true,
          message: this.$t('playTurbo.custom.difficultySlider.form.max.required'),
          trigger: 'change'
        }, {
          validator: this.validateNumber,
          trigger: 'change'
        }]
      }];
    }
  },

  watch: {
    editPopoverVisible: function editPopoverVisible(val) {
      if (val === true) {
        this.formValue = {
          min: this.min,
          max: this.max
        };
      }
    }
  },

  methods: {
    validateNumber: function validateNumber(rule, value, callback) {
      value = Number(value);

      if (value > _Number$MAX_SAFE_INTEGER) {
        callback(new Error('' + this.$t('playTurbo.custom.difficultySlider.form.min.warningLable') + value + this.$t('playTurbo.custom.difficultySlider.form.min.warningText2')));
        return;
      }

      if (value < _Number$MIN_SAFE_INTEGER) {
        callback(new Error('' + this.$t('playTurbo.custom.difficultySlider.form.min.warningLable') + value + this.$t('playTurbo.custom.difficultySlider.form.min.warningText3')));
        return;
      }

      var min = Number(this.formValue.min);
      var max = Number(this.formValue.max);
      if (min >= max) {
        callback(new Error(this.$t('playTurbo.custom.difficultySlider.form.min.warningText4')));
        return;
      }

      callback();
    },
    submit: function submit() {
      var _this = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          var _formValue = _this.formValue,
              min = _formValue.min,
              max = _formValue.max;

          min = Number(min);
          max = Number(max);
          _this.$emit('change', {
            min: min,
            max: max
          });
          _this.hideEditPopover();
        }
      });
    },
    hideEditPopover: function hideEditPopover() {
      this.editPopoverVisible = false;
    }
  }
};